<script setup>
import * as yup from 'yup';
import { ErrorMessage, Field, useForm } from 'vee-validate';
import { __, isNumber } from '@/utils';
import Modal from "@components/modal.vue";

const props = defineProps({
  isActive: {
	type: Boolean,
	default: false
  },
  isSuccess: {
	type: Boolean,
	default: false
  },
  selectedModalData: {
	type: Object,
  }
});

const emit = defineEmits(['close', 'submit']);

const { errors, handleSubmit } = useForm({
	keepValuesOnUnmount: true,
	validationSchema: yup.object({
		phone: yup.string()
		.transform(value => value ? value.toString().trim() : value)
		.matches(/^\d{10}$/, __('A valid phone number must be entered'))
		.required(__('Required field')),
	}),
});

const onSubmit = handleSubmit(async (formValues) => {
	emit('submit', formValues);
});
</script>
<template>
	<Modal :isActive="isActive" class="popup--settings-busy" @close="$emit('close')">
		<template #head>
			<h3>
				{{ __('Call forwarding if busy') }}
			</h3>
		</template>
	
		<template #body>
			
			<p>
				<strong>{{ selectedModalData['modalText'] }}</strong>
			</p>
			<form @submit="onSubmit">
				<div class="field" :class="{'field--has-error': errors.phone }">
					<Field
						type="text"
						name="phone"
						@keypress="isNumber($event)"
						maxlength="10"
						:placeholder="__('Type a phone number...')"
					/>
					<ErrorMessage name="phone" class="error-message fz13" />
				</div>
		
				<div class="confirm-btn-holder mb16">
					<button type="submit" class="btn w160 mb14 w224">
						{{ __('Approval') }}
					</button>
				</div>
				<button type="button" class="link-underline" @click="$emit('close')">
					{{ __('cancellation') }}
				</button>
			</form>
		</template>
	</Modal>
	
</template>